import { useState } from 'react';
import { SpaceProps, ColorProps, BordersProps, LayoutProps } from 'styled-system';
import { LabelBold } from '../typography/typography';
import { variants, variantsRotate, Wrapper, MotionIconWrapper, Flex, ContentWrapper } from './collapse-view';

interface Props extends SpaceProps, ColorProps, BordersProps, LayoutProps {
	label: string;
	secondLabel?: string;
	renderTitle?: () => React.ReactNode;
	contentWrapperClassName?: string;
	dataAt?: string;
	children: React.ReactNode;
	iconBottom?: React.ReactNode;
	backgroundColor?: string;
	openByDefault?: boolean;
	contentWrapperMarginTop?: string;
}

function Collapse({
	label,
	renderTitle,
	contentWrapperClassName,
	dataAt,
	children,
	iconBottom,
	secondLabel,
	contentWrapperMarginTop = '7',
	openByDefault = false,
	...rest
}: Props) {
	const [collapse, setCollapse] = useState(!openByDefault);

	const toggleCollapse = () => {
		setCollapse(!collapse);
	};

	return (
		<Wrapper {...rest} data-collapsed={collapse}>
			{renderTitle ? (
				<Flex onClick={() => toggleCollapse()} data-at={dataAt} className="collapse-title">
					{renderTitle()}
				</Flex>
			) : (
				<Flex onClick={() => toggleCollapse()} data-at={dataAt} className="collapse-title">
					{secondLabel ? (
						<>
							<LabelBold m={0}>{label}</LabelBold>
							<LabelBold m={0} textAlign="right" style={{ right: 56, position: 'absolute' }}>
								{secondLabel}
							</LabelBold>
						</>
					) : (
						<LabelBold m={0}>{label}</LabelBold>
					)}
					{iconBottom && (
						<MotionIconWrapper
							initial="down"
							variants={variantsRotate}
							animate={collapse ? 'down' : 'up'}
							transition={{
								x: { type: 'spring', stiffness: 100, damping: 100 }
							}}
						>
							{iconBottom}
						</MotionIconWrapper>
					)}
				</Flex>
			)}
			<ContentWrapper
				className={contentWrapperClassName}
				initial="hidden"
				variants={variants}
				animate={collapse ? 'hidden' : 'visible'}
				mt={contentWrapperMarginTop}
				bg="transparent"
			>
				{children}
			</ContentWrapper>
		</Wrapper>
	);
}

export { Collapse, variantsRotate, MotionIconWrapper };
